---
type: guest
cover: 'https://media.codingcat.dev/image/upload/main-codingcatdev-photo/podcast-guest/onlyspaceghost'
name: Willow (GHOST)
published: published
slug: willow
start: January 1, 2000
socials:
  github: 'https://github.com/ghostdevv'
  twitter: 'https://twitter.com/onlyspaceghost'
websites:
  - https://www.adewaleabati.com/
  - https://www.madeinnigeria.dev/
---

## About

🧙🏼‍♀️Working on Open Source! [@gitpod](https://twitter.com/gitpod) [@SvelteSirens](https://twitter.com/SvelteSirens)[http://ghostdev.xyz](https://ghostdev.xyz/) (she/her) 🎃 all opinions are my own!
